import React, { useState } from "react";

export default function CopyUrlButton({ url }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      style={{
        padding: "8px 14px",
        border: "1px solid #ddd",
        borderRadius: "4px",
        background: "#fff",
        cursor: "pointer",
        fontSize: "12px",
        fontWeight: 600,
      }}
    >
      {copied ? "✓ Copied!" : "Copy Link"}
    </button>
  );
}
